import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, fetchApi } from "@inmagik/react-crud"
import type { Genre } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useGenresList(params: Record<string, string> = {}) {
  return useList<Genre>(`${API_URL}/admin/genres`, {
    query: params,
  })
}

export function useGenre(id: number | undefined) {
  return useDetail<Genre>(`${API_URL}/admin/genres`, id?.toString())
}

export function useCreateGenre() {
  return useCreate<Genre>(`${API_URL}/admin/genres`)
}

export function useUpdateGenre() {
  return useUpdate<Genre>(`${API_URL}/admin/genres`)
}

export function useDeleteGenre() {
  return useDelete(`${API_URL}/admin/genres`)
}

export function usePartialUpdateGenre() {
  return usePartialUpdate<Genre>(`${API_URL}/admin/genres`)
}

export function useDeleteMultiGenre() {
  return useAction(`${API_URL}/admin/genres/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useGenreLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/genres/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Genre>
  }, [])
}

export function useGenresLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/genres?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Genre[] }>
  }, [])
}
